/**
 * IT Admin → User lookup: what `/it-admin` opens.
 *
 * Since 7 Oct (UAT walkthrough) this is the lookup alone. The tiles that
 * repeated the "IT Admin ▾" menu, the insights links and the empty training
 * tab are gone: the menu is the one way between the IT Admin tools.
 */

import { UserLookupCard } from "./user-lookup-card";

export function ItAdminHubPage() {
  return <UserLookupCard />;
}
